import { useUser } from 'shared/hooks';
import { ManageCustomerParametersPage } from './manage-customer-parameters-page';

export function ManageCustomerParametersResolver() {
  const user = useUser();

  if (!user) {
    return null;
  }

  return <ManageCustomerParametersPage user={user} />;
}
